import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isUserAdmin } from "../utils/authUtils";
import { getLoggedInUser } from "../logic/loginLogic";
import { logSecurityEvent, EVENT_TYPES } from "../utils/securityLogger";

const PrivateAdminRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const user = getLoggedInUser();
      if (user) {
        const adminStatus = await isUserAdmin(user.uid);
        setIsAdmin(adminStatus);
        
        // Log admin access attempts
        if (!adminStatus) {
          await logSecurityEvent(EVENT_TYPES.PERMISSION_DENIED, user.uid, {
            route: window.location.pathname,
            action: 'admin_access_attempt',
            userAgent: navigator.userAgent
          });
        }
      } else {
        // Log unauthorized access attempt
        await logSecurityEvent(EVENT_TYPES.UNAUTHORIZED_ACCESS, null, {
          route: window.location.pathname,
          action: 'admin_access_attempt',
          userAgent: navigator.userAgent
        });
      }
      setLoading(false);
    };

    checkAdmin();
  }, []);

  if (loading) return <div>Loading...</div>;

  return isAdmin ? children : <Navigate to="/" replace />;
};

export default PrivateAdminRoute;
